/**
 * Simple caching class
 * Use with caution : caching usage could have side effects
 */
export class CustomCache {
  /**
   * @param {number|null} maxSize
   */
  constructor(maxSize = null) {
    this._cache = new Map()
    this._maxSize = maxSize
  }

  /**
   * Clear the cache
   */
  clear() {
    this._cache.clear()
  }

  /**
   * Delete a specific key from cache
   * @param {string} key The key to delete
   * @returns {boolean} true if key existed and was deleted
   */
  delete(key) {
    return this._cache.delete(key)
  }

  /**
   * Has key in cache
   * @param {string} key The key to check in cache
   * @returns {boolean}
   */
  has(key) {
    return this._cache.has(key)
  }

  /**
   * Get value in cache
   * @param {string} key The key to get in cache
   * @returns {*}
   */
  get(key) {
    return this._cache.get(key)
  }

  /**
   * Set key / value in cache
   * @param {string} key The key to set in cache
   * @param {*} value The value to set in cache
   * @returns {*} Returns the value which was set
   */
  set(key, value) {
    // First in -- First out
    if (this._maxSize !== null && !this._cache.has(key) && this._cache.size >= this._maxSize) {
      const [firstKey] = this._cache.keys()
      this._cache.delete(firstKey)
    }

    this._cache.set(key, value)

    return this._cache.get(key)
  }

  /**
   * Get key in cache
   * @param {string} key The key to get in cache
   * @param {function} setterFunction A function that returns the value to set if the key does not exist in cache
   * @returns {*}
   */
  getOrSet(key, setterFunction) {
    if (this._cache.has(key)) {
      return this.get(key)
    }

    return this.set(key, setterFunction())
  }
}
